import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { getSessionId } from '../../helpers/storageUtils';
import { UtilsService } from '../../services/utils.service';
import { SarlaftRequest, SarlaftResponse } from '../interfaces/sarlaft.interface';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class SarlaftService {
  private http = inject(HttpClient);
  private tokenService = inject(TokenService);
  private utils = inject(UtilsService);

  private baseUriEvaluationSarlaft = environment.URL_START_SARLAFT;
  private baseUriPullerSarlaft = environment.URL_PULLER_SARLAFT;

  public sarlaftEvaluation(sessionId: string, recordId: string): Observable<SarlaftResponse> {
    const request: SarlaftRequest = {
      input: { recordId },
      product: 'Motos',
    };
    const headers = this.utils.getHeaders(sessionId || getSessionId().toString());
    return this.http.post<SarlaftResponse>(this.baseUriEvaluationSarlaft, request, { headers });
  }

  // El puller ahora recibe los datos que necesita y no tiene lógica de negocio
  public pullerEvaluation(sessionId: string, recordId: string): Observable<SarlaftResponse> {
    const headers = this.utils.getHeaders(sessionId || getSessionId().toString());

    const request: SarlaftRequest = {
      input: { recordId },
      product: 'Motos',
    };

    const pullerUrl = this.baseUriPullerSarlaft;

    return this.http.post<SarlaftResponse>(pullerUrl, request, { headers });
  }
}
